/**
 * Coups de pouce — Attendu 1083 « Lier "une chance sur quatre" et 1/4 ».
 *
 * Entrée PARTAGÉE par les deux sens de traduction (phrase_fraction_qcm_unique,
 * fraction_phrase_qcm_unique) : même geste — le premier nombre en haut, le
 * second (le TOTAL) en bas, jamais l'inverse. L'exemple (revue 2026-09-01)
 * est HORS du vivier : « sept chances sur neuf » (dénominateur 9 absent du
 * pool), code couleur mot → chiffre. SVG pas à pas piloté par les flèches de
 * la sheet (data-etapes / data-caption, mécanisme 2026-08-21).
 *
 * (situation_qcm_unique retiré du gen, revue 2026-09-02 — entrée supprimée.)
 * chances_tableau_vf : entrée AJOUTÉE (revue 2026-09-02, décision prof) —
 * contrairement au V/F du 1084 (faits du modèle, pur rappel), la plupart des
 * lignes se VÉRIFIENT par la méthode de la carte : traduire en fraction puis
 * contrôler (total en bas, valeur entre 0 et 1). Travail résiduel réel ;
 * l'exemple (6/8 = 3/4 vrai, 40/8 faux) est hors des 12 lignes du pool.
 */

const SVG_PHRASE_FRACTION = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 232" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="De la phrase à la fraction, en 3 étapes à faire défiler avec les flèches. La phrase : sept chances sur neuf. Le geste : sept monte en haut de la fraction, neuf descend en bas : la fraction est 7 sur 9. Jamais l'inverse : 9 sur 7 est barré. Le total est toujours en bas">
  <style>
    @keyframes cp1083-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1083-pop { opacity: 0; animation: cp1083-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">La phrase : sept chances sur neuf</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Sept en haut, neuf en bas : 7/9</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Jamais l'inverse : le total reste en bas</text>

  <!-- ── La phrase colorée (étape 1) ─────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <text x="180" y="66" font-size="16" font-weight="700" text-anchor="middle" fill="#111827">
      <tspan fill="#1E3A8A">sept</tspan> chances sur <tspan fill="#1D9E75">neuf</tspan>
    </text>
  </g>

  <!-- ── Le geste : haut et bas (étape 2) ────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1083-pop">
      <path d="M 122 74 C 105 90 112 102 128 111" fill="none" stroke="#1E3A8A" stroke-width="2"/>
      <path d="M 131 113 l -9 -1 l 4 -8 Z" fill="#1E3A8A"/>
      <path d="M 244 74 C 262 104 205 138 160 151" fill="none" stroke="#1D9E75" stroke-width="2"/>
      <path d="M 156 152 l 9 -3 l -2 8 Z" fill="#1D9E75"/>
      <text x="140" y="126" font-size="24" font-weight="800" fill="#1E3A8A" text-anchor="middle">7</text>
      <line x1="120" y1="136" x2="160" y2="136" stroke="#111827" stroke-width="2.4"/>
      <text x="140" y="162" font-size="24" font-weight="800" fill="#1D9E75" text-anchor="middle">9</text>
    </g>
  </g>

  <!-- ── L'anti-piège : l'inversion barrée (étape 3) ─────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1083-pop">
      <text x="280" y="126" font-size="24" font-weight="800" fill="#B45309" text-anchor="middle" opacity="0.75">9</text>
      <line x1="260" y1="136" x2="300" y2="136" stroke="#B45309" stroke-width="2.4" opacity="0.75"/>
      <text x="280" y="162" font-size="24" font-weight="800" fill="#B45309" text-anchor="middle" opacity="0.75">7</text>
      <line x1="256" y1="108" x2="304" y2="170" stroke="#B45309" stroke-width="2.6"/>
      <text x="316" y="120" font-size="16" font-weight="800" fill="#B45309">✗</text>
      <rect x="20" y="188" width="320" height="26" rx="10" fill="#eff6ff" stroke="#bfdbfe"/>
      <text x="180" y="205" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Le total est toujours en bas.</text>
    </g>
  </g>

  <text x="180" y="229" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_TRADUIRE = {
    pages: [
        {
            titre: 'Haut et bas',
            lignes: [
                '**« a chances sur b » s\'écrit a/b** : le premier nombre monte en haut de la fraction, le second descend en bas. Jamais l\'inverse.',
                'Le nombre d\'en bas, c\'est **le total des cas possibles** ; celui d\'en haut, les cas qui conviennent.',
                'Pour relire une fraction en chances : 7/9 se dit « sept chances sur neuf ».',
            ],
        },
        { titre: 'Un exemple : sept chances sur neuf', svg: SVG_PHRASE_FRACTION },
    ],
};

/*
 * chances_tableau_vf : juger une affirmation = la traduire en fraction puis
 * contrôler. Les deux exemples (6/8 = 3/4, et 40/8 > 1) sont hors du pool.
 */
const SVG_TRADUIRE_CONTROLER = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 242" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Juger une affirmation sur les chances, en 3 étapes à faire défiler avec les flèches. L'affirmation : six chances sur huit et trois chances sur quatre désignent la même probabilité. Je traduis les deux phrases en fractions : 6 sur 8 et 3 sur 4 ; en divisant par 2, c'est le même nombre : c'est vrai. Autre phrase : quarante chances sur huit ? La fraction 40 sur 8 est plus grande que 1 : impossible pour une probabilité, c'est faux. Traduis en fraction, puis contrôle">
  <style>
    @keyframes cp1083c-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1083c-pop { opacity: 0; animation: cp1083c-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Six sur huit et trois sur quatre : pareil ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Je traduis : 6/8 = 3/4, même nombre : VRAI</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">40/8 ? Plus grand que 1 : FAUX</text>

  <!-- ── L'affirmation à juger (étape 1) ─────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <text x="180" y="52" font-size="13" font-weight="700" fill="#111827" text-anchor="middle">« Six chances sur huit » et « trois chances</text>
    <text x="180" y="70" font-size="13" font-weight="700" fill="#111827" text-anchor="middle">sur quatre » : la même probabilité ?</text>
  </g>

  <!-- ── Traduire puis comparer (étape 2) ────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1083c-pop">
      <rect x="70" y="92" width="60" height="26" rx="8" fill="#eff6ff" stroke="#1E3A8A"/>
      <text x="100" y="110" font-size="14" font-weight="800" fill="#1E3A8A" text-anchor="middle">6/8</text>
      <!-- « = » bien visible (revue 2026-09-02 : à petite taille, un = fin se
           lit comme un tiret de soustraction) -->
      <text x="150" y="112" font-size="22" font-weight="800" fill="#1D9E75" text-anchor="middle">=</text>
      <rect x="170" y="92" width="60" height="26" rx="8" fill="#eff6ff" stroke="#1E3A8A"/>
      <text x="200" y="110" font-size="14" font-weight="800" fill="#1E3A8A" text-anchor="middle">3/4</text>
      <rect x="128" y="70" width="44" height="18" rx="8" fill="#ecfdf5" stroke="#1D9E75"/>
      <text x="150" y="83" font-size="11" font-weight="800" fill="#1D9E75" text-anchor="middle">÷ 2</text>
      <rect x="260" y="93" width="70" height="24" rx="8" fill="#ecfdf5" stroke="#1D9E75"/>
      <text x="295" y="110" font-size="12.5" font-weight="800" fill="#1D9E75" text-anchor="middle">VRAI</text>
    </g>
  </g>

  <!-- ── Le contrôle des bornes (étape 3) ────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1083c-pop">
      <text x="8" y="152" font-size="13" font-weight="700" fill="#111827">Et « quarante chances sur huit » ?</text>
      <rect x="90" y="162" width="60" height="26" rx="8" fill="#fffbeb" stroke="#B45309"/>
      <text x="120" y="180" font-size="14" font-weight="800" fill="#B45309" text-anchor="middle">40/8</text>
      <line x1="86" y1="188" x2="154" y2="162" stroke="#B45309" stroke-width="2.2"/>
      <text x="164" y="180" font-size="12.5" font-weight="700" fill="#B45309">plus grand que 1 !</text>
      <rect x="282" y="163" width="70" height="24" rx="8" fill="#fffbeb" stroke="#B45309"/>
      <text x="317" y="180" font-size="12.5" font-weight="800" fill="#B45309" text-anchor="middle">FAUX</text>
      <rect x="20" y="200" width="320" height="26" rx="10" fill="#eff6ff" stroke="#bfdbfe"/>
      <text x="180" y="217" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Traduis en fraction, puis contrôle.</text>
    </g>
  </g>

  <text x="180" y="239" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const CP_1083 = {
    phrase_fraction_qcm_unique: AIDE_TRADUIRE,
    fraction_phrase_qcm_unique: AIDE_TRADUIRE,
    chances_tableau_vf: {
        pages: [
            {
                titre: 'Traduire, puis contrôler',
                lignes: [
                    '**Traduis chaque phrase en fraction** : « a chances sur b », c\'est a/b. Une affirmation sur les chances se juge en fraction.',
                    '**Contrôle deux choses** : le nombre d\'en bas doit être le total, et la fraction doit rester entre 0 et 1.',
                    'Exemple de contrôle : « quarante chances sur huit » donnerait 40/8, plus grand que 1 — une phrase de chances ne peut pas dire ça.',
                ],
            },
            { titre: 'Un exemple : juger deux phrases', svg: SVG_TRADUIRE_CONTROLER },
        ],
    },
};

export default CP_1083;
